export { globalApps as default, init } from './src/index';
